import React, { Component } from 'react'
import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import { CheckboxStyle } from './style'
import { Image } from '../../components'
import { ICONS } from '../../themes'

export class Checkbox extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isChecked: false,
      // value: !this.setState.isChecked,
    }
  }

  handleChange = () => {
    this.setState(prevState => ({
      isChecked: !prevState.isChecked,
      // value: event.target.value,
    }))
  }

  render() {
    const {
      className,
      children,
      defaultChecked,
      onChange,
      id,
      type,
      name,
      // isChecked
      checked,
      isCheckedSub,
      value,
      isDisable,
      disabled,
      isDisabled,
      style,
    } = this.props

    const { isChecked } = this.state
    return (
      <CheckboxStyle
        className={ClassNames(
          'checkbox',
          { 'is-checked': onChange ? checked : isChecked },
          { 'is-checked-sub': isCheckedSub },
          { 'is-radio-type': type === 'radio' },
          { 'is-disabled': isDisable || disabled || isDisabled },
          className
        )}
        style={style}
      >
        <input
          className="real-input"
          type={type}
          defaultChecked={defaultChecked}
          checked={onChange ? checked : isChecked}
          onChange={onChange ? onChange : () => this.handleChange()}
          id={id}
          name={name}
          value={value || ''}
        />
        <label className="fake-input" htmlFor={id}>
          <span
            className={ClassNames('fake-checkbox', {
              'checkbox-award': className === 'checkbox-award',
            })}
          >
            <Image src={ICONS['icon-check.svg']} className="check-icon" />
          </span>
          <span className="fake-label">{children}</span>
        </label>
      </CheckboxStyle>
    )
  }
}

Checkbox.defaultProps = {
  type: 'checkbox',
}

// eslint-disable-next-line react/no-typos
Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
}
